import { defineStore } from 'pinia'
import { request } from '../../scripts/utils'

export const useCustomerStore = defineStore('customer', {
  state: () => ({
    customerData: null
  }),
  
  getters: {
    getCustomerData: (state) => state.customerData,
  },
  
  actions: {
    async fetchCustomerData() {
      try {
        const res = await request('portal/customers', null, true, 'GET')
        if (res?.data) {
          this.customerData = res.data
          sessionStorage.setItem('customer', JSON.stringify(res.data))
        }
        return this.customerData
      } catch (error) {
        console.error('Failed to fetch customer data:', error)
        return null
      }
    },
    setCustomerData(data) {
      this.customerData = data
      if (data) {
        sessionStorage.setItem('customer', JSON.stringify(data))
      }
    },

    clearCustomerData() {
      this.customerData = null
      sessionStorage.removeItem('customer')
    }
  }
})

